
import { FileList } from "./FileList";
import { CustomNameInput } from "./CustomNameInput";
import { UploadActions } from "./UploadActions";

interface UploadFormProps {
  files: File[];
  customName: string;
  onCustomNameChange: (value: string) => void;
  onRemoveFile: (index: number) => void;
  onUpload: () => void;
}

export function UploadForm({
  files,
  customName,
  onCustomNameChange,
  onRemoveFile,
  onUpload
}: UploadFormProps) {
  return (
    <div className="w-full">
      <CustomNameInput
        value={customName}
        onChange={onCustomNameChange}
      />
      <div className="mt-6 space-y-4 animate-fade-in w-full">
        <FileList files={files} onRemove={onRemoveFile} />
        <UploadActions
          filesCount={files.length}
          onUpload={onUpload}
        />
      </div>
    </div>
  );
}
